import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { ICommonStore } from "./interface";
import { constantModal, constantOpenModalFailed } from "./constant";

const commonStore = create<ICommonStore>()(
  devtools((set) => ({
    openModalFailed: constantOpenModalFailed,
    setOpenModalFailed: (e) =>
      set((state: ICommonStore) => ({
        ...state,
        openModalFailed: { ...state?.openModalFailed, ...e },
      })),
    loading: [],
    setLoading: (e) =>
      set((state: ICommonStore) => {
        const existingItem = state.loading.find(
          (item) => item.name === e.name,
        );

        const updatedLoading = existingItem
          ? state.loading.map((item) =>
              item.name === e.name ? { ...item, status: e.status } : item,
            )
          : [...state.loading, e];

        return {
          ...state,
          loading: updatedLoading,
        };
      }),
    clearLoading: () =>
      set((state: ICommonStore) => {
        return {
          ...state,
          loading: [],
        };
      }),
    openCenteredModal: constantModal,
    setOpenCenteredModal: (e) =>
      set((state: ICommonStore) => ({
        ...state,
        openCenteredModal: { ...state?.openCenteredModal, ...e },
      })),
    clearCenteredModal: () =>
      set((state: ICommonStore) => {
        return {
          ...state,
          openCenteredModal: constantModal,
        };
      }),
  })),
);

export default commonStore;
